import { render, staticRenderFns } from "./TheUserUI.vue?vue&type=template&id=5ec32ea5&scoped=true&"
import script from "./TheUserUI.vue?vue&type=script&lang=js&"
export * from "./TheUserUI.vue?vue&type=script&lang=js&"
import style0 from "./TheUserUI.vue?vue&type=style&index=0&id=5ec32ea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec32ea5",
  null
  
)

export default component.exports